declare global {
  interface Window {
    umami?: { track: (event: string, data?: Record<string, unknown>) => void };
  }
}

const SOCIAL_PLATFORMS: [string, string][] = [
  ['instagram.com', 'instagram'],
  ['spotify.com', 'spotify'],
  ['music.apple.com', 'apple_music'],
  ['youtube.com', 'youtube'],
  ['tiktok.com', 'tiktok'],
];

function trackEvent(event: string, data?: Record<string, unknown>): void {
  window.umami?.track(event, data);
}

export function initAnalytics(): void {
  document.querySelectorAll<HTMLAnchorElement>('a[href*="discord.com"]').forEach(el => {
    el.addEventListener('click', () => trackEvent('discord_click', { category: 'engagement' }));
  });

  SOCIAL_PLATFORMS.forEach(([domain, platform]) => {
    document.querySelectorAll<HTMLAnchorElement>(`a[href*="${domain}"]`).forEach(el => {
      el.addEventListener('click', () => trackEvent('social_click', { platform }));
    });
  });
}

export function trackNewsletterSignup(): void {
  trackEvent('newsletter_signup', { category: 'engagement' });
}
